export default function(character, value)
{
	if (character >= '0' && character <= '9')
	{
		return character
	}
}


// WEBPACK FOOTER //
// ./source/parse digit.js